/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppGetYoutubeIntegrationBroadcastsBroadcastsQueryResponse, WebAppGetYoutubeIntegrationBroadcastsBroadcastsPathParams, WebAppGetYoutubeIntegrationBroadcastsBroadcastsQueryParams, WebAppGetYoutubeIntegrationBroadcastsBroadcasts401, WebAppGetYoutubeIntegrationBroadcastsBroadcasts403 } from "../models/WebAppGetYoutubeIntegrationBroadcastsBroadcasts";

export function getWebAppGetYoutubeIntegrationBroadcastsBroadcastsUrl(station: WebAppGetYoutubeIntegrationBroadcastsBroadcastsPathParams["station"]) {
  const res = { method: 'GET', url: `/web-app/v1/youtube-broadcasts/${station}` as const }
  return res
}

/**
 * @description Computes on-air intervals from stream gaps in the requested window and enriches them with live/ended YouTube video metadata for the station channel.
 * @summary List on-air broadcasts for a station
 * {@link /web-app/v1/youtube-broadcasts/:station}
 */
export async function webAppGetYoutubeIntegrationBroadcastsBroadcasts(station: WebAppGetYoutubeIntegrationBroadcastsBroadcastsPathParams["station"], params: WebAppGetYoutubeIntegrationBroadcastsBroadcastsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<WebAppGetYoutubeIntegrationBroadcastsBroadcastsQueryResponse, ResponseErrorConfig<WebAppGetYoutubeIntegrationBroadcastsBroadcasts401 | WebAppGetYoutubeIntegrationBroadcastsBroadcasts403>, unknown>({ method : "GET", url : getWebAppGetYoutubeIntegrationBroadcastsBroadcastsUrl(station).url.toString(), params, ... requestConfig })
  return res.data
}